import { useState, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const location = useLocation();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (!loading && user && (user.role === "admin" || user.role === "guruji" || user.role === "helper")) {
    if (user.role === "helper") return <Navigate to="/helper" replace />;
    if (user.role === "guruji") return <Navigate to="/admin/home" replace />;
    const from = location.state?.from?.pathname || "/admin";
    return <Navigate to={from} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) {
      // AuthContext now has the user; redirect-effect above will run on next render via the guard.
      nav("/admin", { replace: true });
    } else {
      toast.error(r.error || "Login failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-paper p-6">
      <form onSubmit={submit} className="w-full max-w-sm card-elevated rounded-md p-8" data-testid="admin-login-form">
        <div className="text-overline mb-3">Acharya Guruji</div>
        <h1 className="font-heading text-3xl">Admin Sign In</h1>
        <div className="mt-6 space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" />
          </div>
          <button type="submit" disabled={busy} className="w-full px-5 py-2.5 rounded-full btn-brand text-sm disabled:opacity-60" data-testid="admin-login-submit">
            {busy ? "Signing in..." : "Sign In"}
          </button>
        </div>
      </form>
    </div>
  );
}
